import { useState, useEffect, Fragment, CSSProperties } from "react";
import { 
    StyleSheet, View, Text
} from "react-native";

import { ReactComponent as PaginationLeftNormalImg } from "../../../img/btn-pagination-left-normal.svg";
import { ReactComponent as PaginationLeftHoverImg } from "../../../img/btn-pagination-left-hover.svg";
import { ReactComponent as PaginationLeftActiveImg } from "../../../img/btn-pagination-left-active.svg";
import { ReactComponent as PaginationRightNormalImg } from "../../../img/btn-pagination-right-normal.svg";
import { ReactComponent as PaginationRightHoverImg } from "../../../img/btn-pagination-right-hover.svg";
import { ReactComponent as PaginationRightActiveImg } from "../../../img/btn-pagination-right-active.svg";
import { FONT } from "../../../value/staticValues";


interface PaginationProps {
    pageIndex: number,
    pageSize: number,
    page, canPreviousPage, canNextPage,  pageOptions, pageCount, gotoPage, nextPage, previousPage,  setPageSize,
    totalItemCount: number,
}


function Pagination(props:PaginationProps) {
    const [paginationLeftState, setPaginationLeftState] = useState("");
    const [paginationRightState, setPaginationRightState] = useState("");
    const [pageIndex, setPageIndex] = useState(props.pageIndex + 1);
    
    function paginationButtonHover(direction:string, outYn:boolean) {
        if(outYn) {
            if(direction === "LEFT") {
                setPaginationLeftState("");
            } else {
                setPaginationRightState("");
            }
        } else {
            if(direction === "LEFT") {
                if(paginationLeftState !== "active") {
                    setPaginationLeftState("hover");
                }
            } else {
                if(paginationRightState !== "active") {
                    setPaginationRightState("hover");
                }
            }
        }
        
    }

    function paginationButtonActive(direction:string, upYn:boolean) {
        if(direction === "LEFT") {
            if(upYn) {
                setPaginationLeftState("");    
            } else {
                setPaginationLeftState("active");
                props.previousPage();
            }
            
        } else {
            if(upYn) {
                setPaginationRightState("");    
            } else {
                setPaginationRightState("active");
                props.nextPage();
            }
        }
    }
    useEffect(() => {
        setPageIndex(props.pageIndex + 1);
    },[props.pageIndex]);

    
    return (
            <Fragment>
                <div style={className.tablePagination}>
                    <Text style={style.tablePaginationText}>Showing</Text>
                    <Text style={style.tablePaginationRange}>{props.pageSize * (props.pageIndex) + 1}-{props.pageSize * (props.pageIndex) + props.page.length}</Text>
                    <Text style={style.tablePaginationText}>of</Text>
                    <Text style={style.tablePaginationTotalCount}>{props.totalItemCount} items</Text>
                    <View style={style.tablePaginationTextDivContainer}></View>
                    <Text style={style.tablePaginationText}>Show page</Text>
                    <input style={className.tablePaginationCurrentPageInput}
                        value={pageIndex}
                        onChange={(e)=> {const page = e.target.value ? Number(e.target.value) - 1 : 0; props.gotoPage(page);}}
                        />
                    <Text style={style.tablePaginationText}>of</Text>
                    <Text style={style.tablePaginationTotalPageValue}>{props.pageOptions.length}</Text>
                    <div style={className.tablePaginationLeftButtonContainer}
                        onMouseOver={()=> {paginationButtonHover("LEFT", false);}}
                        onMouseOut={()=> {paginationButtonHover("LEFT", true);}}
                        onMouseDown={()=> {paginationButtonActive("LEFT", false)}}
                        onMouseUp={()=> {paginationButtonActive("LEFT", true)}}
                    >
                    {
                        paginationLeftState === "hover" ? <PaginationLeftHoverImg style={className.PaginationArrowImg} /> : paginationLeftState === "active" ? <PaginationLeftActiveImg style={className.PaginationArrowImg} /> : <PaginationLeftNormalImg style={className.PaginationArrowImg} />
                    }
                    </div>
                    
                    <div style={className.tablePaginationRightButtonContainer}
                        onMouseOver={()=> {paginationButtonHover("RIGHT", false);}}
                        onMouseOut={()=> {paginationButtonHover("RIGHT", true);}}
                        onMouseDown={()=> {paginationButtonActive("RIGHT", false)}}
                        onMouseUp={()=> {paginationButtonActive("RIGHT", true)}}

                    >
                    {
                        paginationRightState === "hover" ? <PaginationRightHoverImg style={className.PaginationArrowImg} /> : paginationRightState === "active" ? <PaginationRightActiveImg style={className.PaginationArrowImg} /> : <PaginationRightNormalImg style={className.PaginationArrowImg} />
                    }
                    </div>
                    <select
                        style={className.tablePaginationSizeSelect}
                        value={props.pageSize}
                        onChange={e => {
                            props.setPageSize(Number(e.target.value))
                        }}
                        
                        
                    >
                        {[10, 20, 50, 100].map(pageSize => (
                            <option style={{backgroundColor: "red"}} key={pageSize} value={pageSize}>
                            {pageSize} rows
                            </option>
                        ))}
                    </select>
                </div>
            </Fragment>
    );
}

const style = StyleSheet.create({
    tablePaginationText: {
        marginLeft: 8,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 1,
        color: "#8793a3"
    },
    tablePaginationRange: {
        marginLeft: 5,
        fontFamily: FONT.BOLD,
        fontSize: 13,
        lineHeight: 1,
        fontWeight: "bold",
        color: "#8793a3"
    },
    tablePaginationTotalCount: {
        marginLeft: 5,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 1,
        color: "#4f5fd8"
    },
    tablePaginationTotalPageValue: {
        marginLeft: 5,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 1,
        color: "#4f5fd8"
    },
    tablePaginationTextDivContainer: {
        marginLeft: "auto"
    }
});

const className = {
    tablePagination: {
        display: "flex",
        alignItems: "center"
    },
    
    tablePaginationCurrentPageInput: {
        width: 40,
        height: 20,
        marginLeft: 5,
        borderWidth: "0px",
        boxShadow: "0 0 0 1px #e4e7eb",
        outline: "none",
        borderRadius: "4px",
        textAlign: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 1,
        color: "#8793a3"
    } as CSSProperties,
    
    tablePaginationLeftButtonContainer: {
        display: "flex",
        alignItems: "center",
        marginLeft: "8px",
    },
    tablePaginationRightButtonContainer: {
        display: "flex",
        alignItems: "center",
        marginLeft: "5px",
    },
    tablePaginationSizeSelect: {
        marginLeft: "27px",
        border : "0px",
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        letterSpacing: "-0.04px",
        color: "#3a3b3f"
    },
    tablePaginationSizeSelectOption: {
        width: 100,
        border : "0px",
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        letterSpacing: "-0.04px",
        color: "#3a3b3f",
        backgroundColor: "#000"
    },
    PaginationArrowImg: {
        width: "20px",
        height: "20px"
    }
};



export default Pagination;